import { render, staticRenderFns } from "./BlockContentHeadline.vue?vue&type=template&id=36c20e79"
import script from "./BlockContentHeadline.vue?vue&type=script&lang=js"
export * from "./BlockContentHeadline.vue?vue&type=script&lang=js"
import style0 from "./BlockContentHeadline.vue?vue&type=style&index=0&id=36c20e79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports